import React from "react";

const SIGNS = ["\u2648", "\u2649", "\u264A", "\u264B", "\u264C", "\u264D", "\u264E", "\u264F", "\u2650", "\u2651", "\u2652", "\u2653"];
const C = 200;

// Decorative rotating astrology wheel (pure SVG + CSS animation).
export default function ZodiacWheel({ className = "", stroke = "rgba(212,175,55,0.55)" }) {
  const symbolR = 170;
  const tickR = 196;
  return (
    <svg viewBox="0 0 400 400" className={className} aria-hidden="true" data-testid="zodiac-wheel">
      {/* Outer rotating assembly */}
      <g className="spin-slow" style={{ transformOrigin: "200px 200px" }}>
        <circle cx={C} cy={C} r="198" fill="none" stroke={stroke} strokeWidth="0.8" />
        <circle cx={C} cy={C} r="176" fill="none" stroke={stroke} strokeWidth="0.6" opacity="0.6" />
        {/* 12 divider spokes + ticks */}
        {SIGNS.map((_, i) => {
          const a = (i * 30 * Math.PI) / 180;
          const x1 = C + 176 * Math.cos(a);
          const y1 = C + 176 * Math.sin(a);
          const x2 = C + 198 * Math.cos(a);
          const y2 = C + 198 * Math.sin(a);
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={stroke} strokeWidth="0.7" opacity="0.7" />;
        })}
        {/* Fine ticks */}
        {Array.from({ length: 60 }).map((_, i) => {
          const a = (i * 6 * Math.PI) / 180;
          const r0 = tickR - (i % 5 === 0 ? 8 : 4);
          return (
            <line key={i} x1={C + r0 * Math.cos(a)} y1={C + r0 * Math.sin(a)} x2={C + tickR * Math.cos(a)} y2={C + tickR * Math.sin(a)} stroke={stroke} strokeWidth="0.4" opacity="0.4" />
          );
        })}
        {SIGNS.map((s, i) => {
          const a = ((i * 30 - 90) * Math.PI) / 180;
          const x = C + symbolR * Math.cos(a);
          const y = C + symbolR * Math.sin(a);
          return (
            <text key={i} x={x} y={y} fontSize="20" textAnchor="middle" dominantBaseline="central" fill="rgba(226,232,240,0.75)">
              {s}
            </text>
          );
        })}
      </g>
      {/* Inner counter-rotating ring */}
      <g className="spin-rev" style={{ transformOrigin: "200px 200px" }}>
        <circle cx={C} cy={C} r="128" fill="none" stroke="rgba(56,189,248,0.4)" strokeWidth="0.6" strokeDasharray="2 6" />
        <circle cx={C} cy={C} r="96" fill="none" stroke="rgba(16,185,129,0.4)" strokeWidth="0.6" />
        {Array.from({ length: 8 }).map((_, i) => {
          const a = (i * 45 * Math.PI) / 180;
          return <circle key={i} cx={C + 96 * Math.cos(a)} cy={C + 96 * Math.sin(a)} r="1.6" fill="rgba(212,175,55,0.8)" />;
        })}
      </g>
      {/* Static core */}
      <circle cx={C} cy={C} r="60" fill="none" stroke={stroke} strokeWidth="0.7" opacity="0.5" />
    </svg>
  );
}
